
export default class LoadingState {
  constructor (element) {
    element.addEventListener('click', () => {
      element.classList.add('is-loading')
    })
  }
}
